import {
  BtnContainer,
  ButtonRedireccion,
  ButtonResetClave,
  CruzContainer,
  Header,
  ModalBody,
  RedireccionContainer,
  TecladoWrapper,
  TecladoInner,
} from "./localStyle";
import { GlobalContext } from "global/context/Provider";
import { useContext, useState, useEffect } from "react";
import { loginApp } from "global/context/action/auth/login";
import { showToaster } from "global/context/action/toaster/toaster";
import { regexNumero } from "global/utils/expresionesRegulares";
import { FaSpinner } from "react-icons/fa";
import TecladoAlfanumerico from "_+_Portal/components/Genericos/TecladoAlfanumerico/TecladoAlfanumerico";
import Keyboard from "../Keyboard/Keyboard";
import { getLocalStorage } from "global/utils/safeJsonParse";

const PedirClave = ({ dissmiss, dniPaciente, navigateTo, obtenerClave }) => {
  const { authDispatch, toasterDispatch } = useContext(GlobalContext);
  const [formPac, setFormPac] = useState({
    txtDni: dniPaciente.toString(),
    txtPassword: "",
  });
  const [loadingBtn, setLoadingBtn] = useState(false);
  const configParse = getLocalStorage("config", {});
  let idTerminal = getLocalStorage("idTerminal");
  const { sectorTurno } = configParse;

  // Show keyboard only on tablet/desktop
  const [isTabletOrDesktop, setIsTabletOrDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 768 : true
  );
  useEffect(() => {
    const onResize = () => setIsTabletOrDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Sincronizar con sessionStorage para el teclado externo
  useEffect(() => {
    sessionStorage.setItem("pedirClavePassword", formPac.txtPassword);
  }, [formPac.txtPassword]);

  // Escuchar cambios desde el teclado externo
  useEffect(() => {
    const interval = setInterval(() => {
      const externalPassword = sessionStorage.getItem("pedirClavePassword");
      if (externalPassword !== null) {
        setFormPac((prev) => {
          if (externalPassword !== prev.txtPassword) {
            return {
              ...prev,
              txtPassword: externalPassword,
            };
          }
          return prev;
        });
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  // Limpiar sessionStorage al montar/desmontar
  useEffect(() => {
    sessionStorage.setItem("pedirClavePassword", "");
    return () => {
      sessionStorage.removeItem("pedirClavePassword");
    };
  }, []);

  const onChangePassword = (e) => {
    setFormPac({
      ...formPac,
      txtPassword: e.target.value,
    });
  };

  // Maneja el cambio desde el teclado alfanumérico
  const handleKeyboardChange = (newValue) => {
    setFormPac({
      ...formPac,
      txtPassword: newValue,
    });
  };

  // Maneja el delete desde el teclado
  const handleKeyboardDelete = () => {
    const currentValue = formPac.txtPassword || "";
    const newValue = currentValue.slice(0, -1);
    setFormPac({
      ...formPac,
      txtPassword: newValue,
    });
  };

  const ingresarClave = () => {
    setLoadingBtn(true);
    loginApp(formPac, sectorTurno, nextStep)(authDispatch);
  };

  const olvideClave = () => {
    obtenerClave();
  };

  const nextStep = (isCorrect, data) => {
    if (isCorrect) {
      showToaster(
        {
          texto: "Clave ingresada correctamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      sessionStorage.setItem("claveVerificada", "true");
      dissmiss();
      navigateTo();
    } else {
      showToaster(
        {
          texto: "Clave incorrecta",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    setLoadingBtn(false);
  };

  const onKeyPress = (e) => {
    if (!regexNumero.test(e.key) && e.key !== "Backspace") {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      ingresarClave();
    }
  };

  return (
    <RedireccionContainer>
      <Header>
        <span className={`${idTerminal ? "rb22t" : "rb16l"} c-white`} style={{ paddingRight: "20px" }}>
          Escribí tu clave de acceso al portal
        </span>
        <CruzContainer onClick={dissmiss}>
          <div className="line1"></div>
          <div className="line2"></div>
        </CruzContainer>
      </Header>
      <ModalBody>
        <span className={`${idTerminal ? "rb22t" : "rb16l"} c-black`}>
          Ingresá la clave de tu cuenta para continuar con la búsqueda de
          turnos.
        </span>
        <p className={`${idTerminal ? "rb18m" : "rb16l"} c-black`}>
          ¿No la sabés? Hacé click en "Olvidé mi clave".
        </p>
        <input
          type="password"
          placeholder="Ingresa tu clave"
          className="rb16l c-black"
          onChange={onChangePassword}
          onKeyDown={onKeyPress}
          value={formPac.txtPassword}
          style={{
            width: "100%",
            height: "40px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            padding: "10px",
            marginTop: "10px",
          }}
        />
        <BtnContainer>
          <ButtonResetClave
            onClick={olvideClave}
            className={`bgc-latex30 pointer rb16m c-white`}
          >
            Olvidé mi clave
          </ButtonResetClave>
          <ButtonRedireccion
            onClick={
              formPac.txtPassword === "" || loadingBtn
                ? () => {}
                : ingresarClave
            }
            className={`${
              formPac.txtPassword === "" ? "bgc-grey65" : "bgc-primary pointer"
            } rb16m c-white`}
          >
            {loadingBtn ? <FaSpinner className="fa-spinner" /> : "Ingresar"}
          </ButtonRedireccion>
        </BtnContainer>
      </ModalBody>

      {/* Teclado alfanumérico */}
      {isTabletOrDesktop && (
        <TecladoWrapper>
          <TecladoInner>
            <Keyboard
              value={formPac.txtPassword}
              onChange={handleKeyboardChange}
              onEnter={
                formPac.txtPassword === "" || loadingBtn
                  ? () => {}
                  : ingresarClave
              }
              maxLength={8}
              isPassword={true}
              enterText={"OK"}
            />
          </TecladoInner>
        </TecladoWrapper>
      )}
    </RedireccionContainer>
  );
};

export default PedirClave;
